interface PageParams {
    pathname: string;
    generalKeys: string[];
    tabs: string[];
    theme?: string;
    sites: string[];
}

export const pageParams: PageParams = {
    pathname: 'stream-series-plug-in-solar-battery',
    generalKeys: ['product_spu_bk626', 'product_bk621_ultra_spu', 'product_bk621', 'product_bk624'],
    tabs: ['product', 'Spec', 'support'],
    theme: 'black',
    sites: ['eu', 'uk', 'de', 'fr', 'it', 'es'],
};

export const pathname = pageParams.pathname;
export const generalKeys = pageParams.generalKeys;
export const tabs = pageParams.tabs;
export const theme = pageParams.theme;
export const sites = pageParams.sites;
